import React from 'react';

import {Events} from 'src/analytics';
import {LabelledImage} from 'src/components/shared';
import {CATEGORY, EDITORIAL, PODCAST} from 'src/routes/paths';
import {ChiefLogo} from 'src/svgs/chiefLogo';
import {EditorialRichContent} from 'src/templates/editorial/EditorialContent';
import styled from 'styled-components/macro';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type NextUpFeaturedProps = any;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function toPlainText(blocks: any = []) {
  if (!blocks) {
    return '';
  }
  return (
    blocks
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .map((block: {_type: string; children: any[]}) => {
        if (block._type !== 'block' || !block.children) {
          return '';
        }
        // loop through the children spans, and join the
        // text strings
        return block.children.map(child => child.text).join('');
      })
      .join('\n\n')
      .substring(0, 514)
  );
}

export const NextUpFeatured: React.FC<NextUpFeaturedProps> = (props: NextUpFeaturedProps) => {
  const nextHeroImageExists =
    (!!props.article.heroImage && props.article?.heroImage?.asset?.url) ||
    (props.article?.heroImage && props.article?.heroImage?.asset?.url);
  const imageUrls =
    !!props.article.heroImage && props.article?.heroImage?.asset?.url
      ? props.article?.heroImage?.asset?.url
      : props.article?.heroImage?.asset?.url;
  const imageAltText =
    !!props.article.heroImage && props.article?.heroImage?.asset?.url
      ? props.article?.heroImage?.asset?.altText
      : props.article?.heroImage?.asset?.altText;
  const articleContent = props.article.content ? props.article.content : props.article?.content;
  const slug = typeof props.article.slug === 'string' ? props.article.slug : props.article.slug.current;
  const articleLink = `${props.article.isPodcast ? PODCAST : EDITORIAL}/${slug}`;
  const handleButtonClick = (item: string) => () => {
    Events.didClickButton({item, pageLocation: 'articleFooter', sectionName: 'Next Up Featured'});
  };
  const handleImageClick = (item: string) => () => {
    Events.didClickImage({
      item,
      pageLocation: 'articleFooter',
      sectionName: 'Next Up Featured',
      linkUrl: articleLink,
    });
  };
  const handleTitleClick = (item: string) => () => {
    Events.didClickArticle({
      item,
      pageLocation: 'articleFooter',
      sectionName: 'Next Up Featured (title)',
      linkUrl: articleLink,
    });
  };
  const categoryLink = props.article.editorialCategory?.slug?.current || null;
  return (
    <section className="px-gutter module-spacing" data-module="next-up-featured-article">
      <div className="wrapper-default grid grid-col-4 md:grid-cols-12 gap-8">
        <h2 className="col-span-full type-beta text-green-dark text-center lg:mb-8">
          {props.heading ? props.heading : 'Next Up'}
        </h2>
        <div className="col-span-full grid gap-8 grid-col-4 md:grid-cols-12 relative">
          <div className="col-span-full md:col-span-6 relative">
            <div className="md:absolute w-full h-full">
              <a
                className="z-30 h-full w-full block absolute"
                href={articleLink}
                onClick={handleImageClick(props.article.title)}
              ></a>
              {nextHeroImageExists ? (
                <img
                  className="object-cover w-full h-full"
                  src={imageUrls ? imageUrls : null}
                  alt={imageAltText ? imageAltText : null}
                />
              ) : (
                <div className="absolute w-full h-full object-cover bg-black flex items-center justify-center">
                  <ChiefLogo classes={'mb-2 lg:mb-0 h-[18px] lg:w-25 lg:h-[8%] fill-light-gold'} />
                </div>
              )}
            </div>
          </div>
          <div className="col-span-full md:col-span-6">
            {categoryLink ? (
              <a
                href={`${CATEGORY}/${categoryLink}`}
                onClick={handleTitleClick(props.article.editorialCategory.title)}
                className="block type-eyebrow link-eyebrow mb-2 text-green-dark relative z-20"
              >
                {props.article.editorialCategory.title}
              </a>
            ) : (
              <span className="type-eyebrow text-green-dark block mb-4 relative z-20">
                {props.article.editorialCategory ? props.article.editorialCategory.title : props.article.catgory}
              </span>
            )}

            <a href={articleLink} onClick={handleTitleClick(props.article.title)}>
              <h2 className="font-serif text-32px leading-snug -tracking-wider lg:text-44px mb-4 relative z-20 link-text">
                {props.article.title}
              </h2>
            </a>
            <div className="relative">
              <div className="type-p">
                {props.article.isPodcast ? toPlainText(props.article.podcastDescription) : toPlainText(articleContent)}
              </div>
            </div>
          </div>
          <div className="absolute bg-gradient-to-t from-white h-full w-full inset-0"></div>
        </div>
        <div className="mt-5 md:mt-4 col-span-full justify-center flex">
          <a href={articleLink} className="button" onClick={handleButtonClick(props.article.title)}>
            {props.cta ? props.cta : 'Read More'}
          </a>
        </div>
      </div>
    </section>
  );
};
